const BaseConfig = {
  AppDisplayName: "Equip Health",
  BundleIdentifier: "com.equip.app",
};

const EnvironmentTypes = {
  Development: "dev",
  Labs: "labs",
  Local: "local",
  Production: "prod",
  QA: "qa",
  Staging: "stg",
  Test: "test",
};

// eslint-disable-next-line no-process-env
const currentEnvironment = process.env.EXPO_PUBLIC_ENVIRONMENT;

const getAppDisplayName = () => {
  const { AppDisplayName } = BaseConfig;
  return AppDisplayName;
};

const getIosAppTransportSecurity = (os) => {
  const LocalhostIpAddress = "127.0.0.1";
  /**
   * Returns the first non-internal IPv4 address of the current machine.
   * If no external IPv4 is found, returns '127.0.0.1'.
   */
  const getLocalIpAddress = () => {
    const interfaces = os.networkInterfaces();
    for (const name of Object.keys(interfaces)) {
      for (const iface of interfaces[name] || []) {
        // eslint-disable-next-line max-depth
        if (iface.family === "IPv4" && !iface.internal) {
          return iface.address;
        }
      }
    }
    return LocalhostIpAddress;
  };
  const LocalIpAddress = getLocalIpAddress();
  // eslint-disable-next-line sonarjs/no-hardcoded-ip
  const LoopBackIpAddress = "10.0.2.2";

  // eslint-disable-next-line no-process-env
  return process.env.NODE_ENV === "development"
    ? {
        NSAllowsArbitraryLoads: false,
        NSAllowsLocalNetworking: true,
        NSExceptionDomains: {
          [LocalhostIpAddress]: {
            NSExceptionAllowsInsecureHTTPLoads: true,
          },
          [LocalIpAddress]: {
            NSExceptionAllowsInsecureHTTPLoads: true,
          },
          [LoopBackIpAddress]: { NSExceptionAllowsInsecureHTTPLoads: true },
        },
      }
    : { NSAllowsArbitraryLoads: false };
};

const getDomainFromURL = (url) => {
  // eslint-disable-next-line no-undef
  const urlObject = new URL(url);
  return urlObject.hostname;
};

const getBundleIdentifier = () => {
  const { BundleIdentifier } = BaseConfig;

  switch (currentEnvironment) {
    case EnvironmentTypes.Development:
      return `${BundleIdentifier}.dev`;
    case EnvironmentTypes.Labs:
      return `${BundleIdentifier}.labs`;
    case EnvironmentTypes.Local:
      return `${BundleIdentifier}.local`;
    case EnvironmentTypes.Production:
      return BundleIdentifier;
    case EnvironmentTypes.QA:
      return `${BundleIdentifier}.qa`;
    case EnvironmentTypes.Staging:
      return `${BundleIdentifier}.stg`;
    case EnvironmentTypes.Test:
      return `${BundleIdentifier}.test`;
  }

  return `${BundleIdentifier}.dev`;
};
const shouldIncludeStorybook =
  currentEnvironment === EnvironmentTypes.Local ||
  currentEnvironment === EnvironmentTypes.Development ||
  currentEnvironment === EnvironmentTypes.Labs;

export {
  EnvironmentTypes,
  getAppDisplayName,
  getBundleIdentifier,
  getDomainFromURL,
  getIosAppTransportSecurity,
  shouldIncludeStorybook,
};
